import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2433d8a2&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=2433d8a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2433d8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2433d8a2')) {
      api.createRecord('2433d8a2', component.options)
    } else {
      api.reload('2433d8a2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2433d8a2&scoped=true", function () {
      api.rerender('2433d8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/components/Category/list.vue"
export default component.exports